const host = window.location.hostname;

const isLocal =
  host === 'localhost' ||
  host === '127.0.0.1' ||
  host.endsWith('.local');

const env = (window as Window & { __ENV__?: Record<string, string | undefined> }).__ENV__ ?? {};
const getEnv = (key: string) => env[key] ?? (process.env as Record<string, string | undefined>)[key];

export const APP_ORIGIN = window.location.origin;

export const AUTH_FRONT_ORIGIN =
  getEnv('REACT_APP_AUTH_FRONT_ORIGIN') ||
  (isLocal ? 'http://localhost:3000' : 'https://auth.omong.kr');

export const API_BASE_URL =
  getEnv('REACT_APP_API_BASE_URL') ||
  (isLocal ? 'http://localhost:8001' : 'https://api.omong.kr');

export const SHORTY_SERVICE_ORIGIN =
  getEnv('REACT_APP_SHORTY_ORIGIN') ||
  (isLocal ? 'http://localhost:5173' : 'https://shorty.omong.kr');

export const CHECKIN_SERVICE_ORIGIN =
  getEnv('REACT_APP_CHECKIN_ORIGIN') ||
  (isLocal ? 'http://localhost:5174' : 'https://checkin.omong.kr');

export const API_V1_PATH = '/api/v1';
